import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function fetchCustomerCart(_x) {
  return _fetchCustomerCart.apply(this, arguments);
}

function _fetchCustomerCart() {
  _fetchCustomerCart = _asyncToGenerator(function* (context) {
    var locale = context.state.i18n.currentLocale;
    var xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/ajax_customer_details.json");
    var {
      data
    } = yield context.$axios.get(xhrUri, {
      withCredentials: true
    });
    return data;
  });
  return _fetchCustomerCart.apply(this, arguments);
}

function addCustomerCartCustomizable(_x2, _x3) {
  return _addCustomerCartCustomizable.apply(this, arguments);
}

function _addCustomerCartCustomizable() {
  _addCustomerCartCustomizable = _asyncToGenerator(function* (context, payload) {
    var locale = context.state.i18n.currentLocale;
    var xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/custom/panier/").concat(payload);
    var {
      data
    } = yield context.$axios.get(xhrUri, {
      'axios-retry': {
        retries: 0
      }
    });
    return data;
  });
  return _addCustomerCartCustomizable.apply(this, arguments);
}

function addCustomerCart(_x4, _x5) {
  return _addCustomerCart.apply(this, arguments);
}

function _addCustomerCart() {
  _addCustomerCart = _asyncToGenerator(function* (context, payload) {
    var locale = context.state.i18n.currentLocale;
    var xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/panier/").concat(payload.referenceEncoded, "/").concat(payload.quantity);
    var {
      data
    } = yield context.$axios.get(xhrUri, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      'axios-retry': {
        retries: 0
      }
    });
    return data;
  });
  return _addCustomerCart.apply(this, arguments);
}

function updateCustomerCart(_x6, _x7) {
  return _updateCustomerCart.apply(this, arguments);
}

function _updateCustomerCart() {
  _updateCustomerCart = _asyncToGenerator(function* (context, payload) {
    var locale = context.state.i18n.currentLocale;
    var xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/panier/changer/").concat(payload.reference, "/").concat(payload.quantity);
    var {
      data
    } = yield context.$axios.get(xhrUri, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    return data;
  });
  return _updateCustomerCart.apply(this, arguments);
}

export { fetchCustomerCart, addCustomerCart, addCustomerCartCustomizable, updateCustomerCart };